import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';
import addOnClickOutside from 'react-onclickoutside';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InputText from 'design-system/InputText';

/** @deprecated - prefer `design-system/Select` (set `multiple` prop to `true`) */
export class Multiselect extends React.Component<$FIXME, $FIXME> {
  constructor(props: $FIXME) {
    super(props);

    this.state = {
      focusedIndex: 0,
      isSelectorOpen: false,
      filterString: '',
      // TODO: use static getDerivedStateFromProps
      options: this.props.options,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      // @ts-ignore
      this.targetRef.focus();
    }
  }

  getPlaceholder() {
    return this.props.placeholder || `${this.props.selected.length} selected`;
  }

  // extracts val from `Add "${val}"`
  cleanText(text: string) {
    const matches = text.match(/"(.*?)"/);
    return matches ? matches[1] : text;
  }

  /* ---------- Interaction handlers ---------------------------------------- */

  handleFilterChange = (e: $FIXME) => {
    const value = this.cleanText(e.target.value);
    const deletingCharacters =
      value.length < (this.state.filterString || _.last(this.props.selected) || '').length;

    if (
      this.props.selected.join().toLowerCase().includes(this.state.filterString.toLowerCase()) &&
      deletingCharacters
    ) {
      // unselect value if deleting characters
      this.handleOptionToggle(this.state.filterString);
    }

    // filter options according to filterString
    const options = !value
      ? this.props.options
      : this.props.options.filter(
          (opt: $FIXME) =>
            opt.toLowerCase().includes(value.toLowerCase()) && !opt.startsWith('Add "'),
        );

    if (value && !options.find((opt: $FIXME) => opt.toLowerCase() === value.toLowerCase())) {
      // add option to create new if no match found
      options.push(`Add "${value}"`);
    }

    this.setState({
      options,
      filterString: value,
      isSelectorOpen: true,
    });
  };

  handleClickOutside() {
    this.setState({
      isSelectorOpen: false,
    });
  }

  handleFocus = () => {
    this.setState({ isSelectorOpen: true });
  };

  handleBlur = () => {
    this.setState({ isSelectorOpen: false });
  };

  handleKeyDown = (e: $FIXME) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const option = this.state.options[this.state.focusedIndex];
      this.handleOptionToggle(option, e);
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      this.setState({ focusedIndex: Math.max(0, this.state.focusedIndex - 1) });
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      this.setState({
        focusedIndex: Math.min(this.state.options.length - 1, this.state.focusedIndex + 1),
      });
    }
  };

  handleToggleSelector = (e: $FIXME) => {
    e.stopPropagation();

    this.setState((prevState: $FIXME) => {
      return {
        isSelectorOpen: !prevState.isSelectorOpen,
      };
    });
  };

  handleOptionToggle = (option: $FIXME, e?: $FIXME) => {
    const cleanedOption = this.cleanText(option);
    const newSelected = this.props.selected.includes(cleanedOption)
      ? _.without(this.props.selected, cleanedOption)
      : _.concat(this.props.selected, [cleanedOption]);

    this.props.handleChange(newSelected);

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  /* ---------- Rendering --------------------------------------------------- */

  renderOption = (option: $FIXME, i: number) => {
    const key = typeof option === 'string' ? option : option.key;
    const val = typeof option === 'string' ? option : option.val;
    const tooltip = _.get(this.props.optionTooltips, i);
    const foundMatch =
      this.props.selected.includes(key) || this.props.selected.includes(this.cleanText(key));

    return (
      <div
        key={key}
        className={classNames('multiselect__selector-option', {
          focused: i === this.state.focusedIndex,
          dense: this.props.dense,
        })}
        onMouseDown={e => this.handleOptionToggle(key, e)}
        onMouseOver={() => this.setState({ focusedIndex: i })}
        data-html={true}
        data-tip={tooltip}
      >
        <span className="multiselect__selector-icon">
          {!foundMatch && (
            <span style={{ color: '#ccc' }}>
              <FontAwesomeIcon icon={['far', 'square']} />
            </span>
          )}
          {foundMatch && (
            <span style={{ color: '#247EFF' }}>
              <FontAwesomeIcon icon="check" />
            </span>
          )}
        </span>

        {val}

        <style jsx>{`
          .multiselect__selector-option {
            padding: 12px;
            display: flex;
            align-items: center;

            white-space: nowrap;
            font-size: 14px;
            color: var(--text-color);

            cursor: pointer;
            user-select: none;
            transition: all 0.2s;
          }

          .multiselect__selector-option.focused {
            background: var(--color-RemoGray01);
          }

          .multiselect__selector-option.dense {
            padding: 6px 12px;
          }

          .multiselect__selector-icon {
            min-width: 22px;
          }
        `}</style>
      </div>
    );
  };

  render() {
    return (
      <div
        className={classNames('multiselect', this.props.position, {
          'multiselect-dense': this.props.dense,
          'multiselect-editable': this.props.editable,
        })}
      >
        <div
          className={classNames(
            'multiselect__target',
            this.props.disabled ? 'multiselect__target-disabled' : 'multiselect__target-enabled',
            this.props.wrapPlaceholder ? {} : { height: '24px' },
          )}
          onMouseDown={this.props.disabled ? undefined : this.handleToggleSelector}
          onKeyDown={this.props.disabled ? undefined : this.handleKeyDown}
          onFocus={this.props.disabled ? undefined : this.handleFocus}
          onBlur={this.props.disabled ? undefined : this.handleBlur}
          tabIndex={0}
          ref={target => {
            // @ts-ignore
            this.targetRef = target;
          }}
        >
          {this.props.editable ? (
            <InputText
              wide
              className="multiselect__target-text"
              value={this.props.selected.join(', ') || this.state.filterString}
              onChange={this.handleFilterChange}
              placeholder={this.getPlaceholder()}
            />
          ) : (
            <span
              className={
                this.props.wrapPlaceholder
                  ? 'multiselect__target-text-wrap'
                  : 'multiselect__target-text-nowrap'
              }
            >
              {this.getPlaceholder()}
            </span>
          )}
          <FontAwesomeIcon
            icon="caret-down"
            style={{ marginLeft: '8px', fontSize: '18px', flexShrink: 0 }}
          />
        </div>

        {this.state.isSelectorOpen && (
          <div className="multiselect__selector branded-scroll">
            {_.map(this.state.options, this.renderOption)}
          </div>
        )}

        <style jsx>{`
          .multiselect {
            position: relative;
          }

          .multiselect__target {
            border-radius: 8px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
            padding: 8px 16px;
            width: 240px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: rgba(0, 0, 0, 0.7);
          }

          .multiselect__target-enabled {
            background: white;
            cursor: pointer;
            user-select: none;
            transition: all 0.2s;
          }

          .multiselect__target-enabled:hover,
          .multiselect__target-enabled:focus {
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
          }

          .multiselect__target-disabled {
            background: #e6e6e6;
          }

          .multiselect__target-text-wrap {
            white-space: normal;
          }

          .multiselect__target-text-nowrap {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .multiselect__selector {
            position: absolute;
            z-index: 100;
            bottom: 52px;
            left: 0;
            min-width: 272px;

            background: white;
            border-radius: 8px;
            border: 1px solid #e0e0e0;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

            max-height: 200px;
            overflow-y: auto;
          }

          .multiselect__selector:after,
          .multiselect__selector:before {
            top: 100%;
            left: 80%;
            border: solid transparent;
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
          }
          .multiselect__selector:after {
            border-color: rgba(255, 255, 255, 0);
            border-top-color: #ffffff;
            border-width: 12px;
            margin-left: -12px;
          }
          .multiselect__selector:before {
            border-color: rgba(255, 0, 0, 0);
            border-top-color: #e0e0e0;
            border-width: 13px;
            margin-left: -13px;
          }

          .bottom .multiselect__selector {
            bottom: inherit;
            top: 48px;
          }

          .multiselect-editable .multiselect__target {
            box-shadow: none !important;
          }

          .multiselect-dense .multiselect__target {
            padding: 0 !important;
          }
        `}</style>
      </div>
    );
  }
}

export default addOnClickOutside(Multiselect);
